module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Chart-bar1-d06f6a9eb620e912968346075f37fa10.svg";